import React, { useState } from "react";
import "../../styles/main.css";
import theme from "../../styles/theme";

import TabsBase from "../../components/reusable/Navigation/TabsBase";
//import JourneyTabs from "../../components/reusable/Navigation/TabsBase";
import ContainerBase from "../../components/framepart/SubpageLayout/ContainerBase";
import ToolbarHeadSubpage from "../../components/framepart/SubpageLayout/ToolbarHeadSubpage";
import DropdownMulti from "../../components/reusable/Forms/DropdownMulti";
import Button from "../../components/reusable/Forms/Button";
import TextFilter from "../../components/reusable/Forms/TextFilter";
import Switch from "../../components/reusable/Forms/Switch";

/* ===== Journey Navigation ===== */

import JourneyTabs from "../../components/reusable/Navigation/JourneyTabs";

/* ===== SPECIFICATION MODULE ===== */

import SpecificationRequirementsTab from "../../components/defined/specification/SpecificationRequirementsTab";
import SpecificationTechnicalTab from "../../components/defined/specification/SpecificationTechnicalTab";
import SpecificationReportTab from "../../components/defined/specification/SpecificationReportTab";

import SpecificationListTab from "../../components/defined/specification/SpecificationListTab";
import SpecificationLibraryTab from "../../components/defined/specification/SpecificationLibraryTab";

import SpecificationMapDetailsPanel from "../../components/defined/specification/SpecificationMapDetailsPanel";


/* ===== SPECIFICATION ANALYSIS ===== */

import SpecificationAnalysisDetailsPanel from "../../components/defined/specification_analysis/SpecificationAnalysisDetailsPanel";
import SpecificationAnalysisTab  from "../../components/defined/specification_analysis/SpecificationAnalysisTab";

/* ===== SPECIFICATION REVIEW ===== */
import SpecificationReviewTab from "../../components/defined/specification_review/SpecificationReviewTab";
import SpecificationReviewPilotPanel from "../../components/defined/specification_review/SpecificationReviewPilotPanel";


/* ===== SPECIFICATION REVIEW ===== */
import SpecificationBuilderTab from "../../components/defined/specification_builder/SpecificationBuilderTab";
import SpecificationBuilderActionPanel from "../../components/defined/specification_builder/SpecificationBuilderActionPanel";


import SpecificationProjectReport from "../../components/defined/specification_builder/SpecificationProjectReport";
// import SpecificationReportConfigPanel from "../../components/defined/specification_builder/SpecificationReportConfigPanel";





import PrintMenuStandard from "../../components/defined/Print/PrintMenuStandard";
/* ============================================================
   MOCK DATA
============================================================ */

const demoOptions = [
  { value: "opt1", label: "Option 1" },
  { value: "opt2", label: "Option 2" },
  { value: "opt3", label: "Option 3" },
];

const demoSpecs = [
  {
    id: "spec1",
    title: "Concrete strength requirement",
    type: "PERFORMANCE",
    section: "GENERAL",
    sentence:
      "Concrete shall reach a compressive strength of 30 MPa at 28 days.",
  },
];

/* ============================================================
   STYLES
============================================================ */

const baseLeftZoneStyle = {
  flex: 3,
  minWidth: 700,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  // background: theme.colors.background.surface,
  // border: `1px solid ${theme.colors.borders.default}`,
  overflowX: "auto",
  overflowY: "auto",
};

const baseRightZoneStyle = {
  flex: 1,
  minWidth: 350,
  minHeight: "calc(100vh - 290px)",
  padding: 12,
  borderRadius: 6,
  // background: theme.colors.background.surface,
  // border: `1px solid ${theme.colors.borders.default}`,
  overflowX: "auto",
  overflowY: "auto",
};

const tabStyle = {
  display: "flex",
  flexDirection: "row",
  gap: 10,
  padding: 10,
};

/* ============================================================
   PAGE
============================================================ */

const Subpage_104 = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [switchOn, setSwitchOn] = useState(false);
  const [activeTab, setActiveTab] = useState(2);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedMapItem, setSelectedMapItem] = useState(null);

  const [journeyStep, setJourneyStep] = useState(0);

  /* ============================================================
     JOURNEY STEPS
  ============================================================ */

  const journeyTabs = [
    { label: "List" },
    { label: "Library" },
    { label: "Builder" },
    { label: "Mapping" },
    { label: "Quality Check" },
  ];

  const journeyProgress = {
    0: 100,
    1: 80,
    2: 60,
    3: 30,
    4: 10,
  };



  const specificationArticles = [
  {
    id: "ART-001",
    code: "HYD-01",
    family: "Hydraulique",
    chapter: "Performances hydrauliques",
    title: "Pression minimale au point défavorisé",
    kind: "Performance",
    status: "Consolidé",
    usageStatus: "Attribué",
  },
  {
    id: "ART-002",
    code: "CIV-10",
    family: "Génie civil",
    chapter: "Ouvrages de stockage",
    title: "Classe de résistance du béton du réservoir",
    kind: "Technique",
    status: "Consolidé",
    usageStatus: "Attribué",
  },
  {
    id: "ART-003",
    code: "ELE-07",
    family: "Électricité / Automatisme",
    chapter: "Commande et continuité de service",
    title: "Alimentation secourue des automatismes",
    kind: "Interface",
    status: "À confirmer",
    usageStatus: "Partiel",
  },
];
  /* ============================================================
     ZONE A — LIST
  ============================================================ */

  const zoneA1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: (
          <SpecificationListTab
            onSelectItem={setSelectedMapItem}
          />
        ),
      },
    ],
  };

  const zoneA2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: (
          <SpecificationMapDetailsPanel
            selectedItem={selectedMapItem}
            onOpenSpecification={(item) => {
              console.log("Voir la fiche :", item);
            }}
            onMarkForReview={(item) => {
              console.log("Marquer pour revue :", item);
            }}
          />
        ),
      },
    ],
  };



  /* ============================================================
   ZONE B — ANALYSIS
============================================================ */

const zoneB1 = {
  style: baseLeftZoneStyle,
  gap: 16,
  sectionGap: 6,
  sections: [
    {
      title: "",
      content: (
        <SpecificationAnalysisTab />
      ),
    },
  ],
};

  const zoneB2 = {
  style: baseRightZoneStyle,
  gap: 12,
  sectionGap: 6,
  sections: [
    {
      title: "Navigator",
      content: (
        <SpecificationAnalysisDetailsPanel />
      ),
    },
  ],
};

  /* ============================================================
     ZONE C — SPECIFICATION
  ============================================================ */

  const zoneC1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: (
          <SpecificationBuilderTab
            items={demoSpecs}
            selectedItemId="spec1"
            onUpdateItem={() => {}}
          />
        ),
      },
    ],
  };

  const zoneC2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: (
          <SpecificationBuilderActionPanel
            items={demoSpecs}
            selectedItemId="spec1"
            onUpdateItem={() => {}}
          />
        ),
      },
    ],
  };

    /* ============================================================
     ZONE D — REVIEW
  ============================================================ */

  const zoneD1 = {
    style: baseLeftZoneStyle,
    gap: 16,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: <SpecificationReviewTab />,
      },
    ],
  };

  const zoneD2 = {
    style: baseRightZoneStyle,
    gap: 12,
    sectionGap: 6,
    sections: [
      {
        title: "",
        content: <SpecificationReviewPilotPanel />,
      },
    ],
  };

  /* ============================================================
     ZONE E — REPORT
  ============================================================ */

  const zoneE1 = {
  style: baseLeftZoneStyle,
  gap: 16,
  sectionGap: 6,
  sections: [
    {
      title: "",
      content: (
        <SpecificationProjectReport
          projectIdentity={{
            projectName: "Projet AEP Nord – Yaoundé",
            reference: "AEP-2026-001",
            clientName: "Ministère de l’Eau et de l’Énergie",
            location: "Yaoundé",
            projectType: "Adduction d’eau potable",
            country: "Cameroun",
          }}
          specificationArticles={[
            {
              id: "ART-001",
              code: "HYD-01",
              family: "Hydraulique",
              chapter: "Performances hydrauliques",
              title: "Pression minimale au point défavorisé",
              kind: "Performance",
              status: "Consolidé",
              usageStatus: "Attribué",
              genericText:
                "La pression minimale au point défavorisé du réseau devra être maintenue à une valeur compatible avec la desserte normale des abonnés et la continuité du service.",
              projectVariant:
                "Pour le présent projet, la pression minimale retenue au point défavorisé est fixée à 2,0 bar en régime normal.",
              projectNote:
                "Cette valeur sera confirmée après validation définitive du modèle hydraulique et des profils topographiques.",
              usedBy: ["Réseau primaire secteur Nord", "Réseau secondaire Messa"],
              disciplines: ["Hydraulique"],
              systems: ["Réseau de distribution"],
              interfaces: ["Pompage", "Stockage"],
              openPoint:
                "Vérifier la tenue de cette exigence en heure de pointe sur la branche Est.",
            },
            {
              id: "ART-002",
              code: "CIV-10",
              family: "Génie civil",
              chapter: "Ouvrages de stockage",
              title: "Classe de résistance du béton du réservoir",
              kind: "Technique",
              status: "Consolidé",
              usageStatus: "Attribué",
              genericText:
                "Les structures en béton armé des ouvrages de stockage devront être conçues avec une classe de résistance adaptée aux sollicitations mécaniques, aux conditions d’exposition et aux objectifs de durabilité.",
              projectVariant:
                "Pour le réservoir principal de 2000 m³, la classe minimale retenue est C35/45.",
              projectNote:
                "Le choix tient compte des conditions d’exposition, de l’environnement humide et des objectifs de durée de vie de l’ouvrage.",
              usedBy: ["Réservoir principal 2000 m³"],
              disciplines: ["Génie civil", "Structure"],
              systems: ["Stockage"],
              interfaces: ["Hydraulique"],
            },
            {
              id: "ART-003",
              code: "ELE-07",
              family: "Électricité / Automatisme",
              chapter: "Commande et continuité de service",
              title: "Alimentation secourue des automatismes",
              kind: "Interface",
              status: "À confirmer",
              usageStatus: "Partiel",
              genericText:
                "Les automatismes assurant les fonctions critiques de l’installation devront être alimentés par une source secourue permettant le maintien des fonctions essentielles en cas de perte de l’alimentation principale.",
              projectVariant:
                "Le principe d’une alimentation par onduleur couplé à un groupe électrogène avec reprise automatique est retenu à ce stade.",
              projectNote:
                "L’autonomie minimale exigée et la hiérarchisation des charges secourues restent à arbitrer.",
              usedBy: ["Station de pompage SP1"],
              disciplines: ["Électricité", "Automatisme"],
              systems: ["Automatisme", "Secours énergie"],
              interfaces: ["Commande", "Supervision", "Pompage"],
              openPoint:
                "Confirmer l’autonomie minimale et la logique de reprise automatique.",
            },
          ]}
          reviewItems={[
            {
              title: "Autonomie des automatismes secourus",
              perimeter: "Station de pompage SP1",
              issueType: "Arbitrage technique",
              impact:
                "Impact direct sur la continuité du service et le dimensionnement des équipements de secours.",
              decision:
                "Valider l’autonomie minimale contractuelle et la liste des charges prioritaires.",
            },
            {
              title: "Pression minimale en heure de pointe",
              perimeter: "Réseau secteur Nord",
              issueType: "Validation hydraulique",
              impact:
                "Impact sur le niveau de service, les diamètres et la robustesse du réseau en exploitation.",
              decision:
                "Confirmer la pression minimale après simulation finale et validation des hypothèses de pointe.",
            },
          ]}
          reportConfig={{
            showSummary: true,
            showScope: true,
            showOverview: true,
            showArticles: true,
            showOpenPoints: true,
            showAppendices: true,
            includeArticleStatus: true,
            includeProjectScope: true,
            includeOpenPointsInBody: true,
            issueLabel: "Version provisoire",
          }}
        />
      ),
    },
  ],
};

  /* ============================================================
   ZONE E2
============================================================ */
const zoneE2 = {
  style: {
    ...baseRightZoneStyle,
    flex: "0 0 480px",
    minWidth: 480,
    maxWidth: 480,
  },
  gap: 12,
  sectionGap: 6,
  sections: [
    {
      icon: "",
      title: "",
      content: (
        <PrintMenuStandard
          items={specificationArticles}
          getItemId={(item) => item.id}
          getItemLabel={(item) =>
            `${item.code || item.id} · ${item.title || "Article sans titre"}${
              item.family ? ` · ${item.family}` : ""
            }`
          }
          isActive={(item) => item.usageStatus !== "Non attribué"}
          templates={[
            {
              value: "spec-summary",
              label: "Synthèse des spécifications",
            },
            {
              value: "spec-dossier",
              label: "Cahier des spécifications",
            },
            {
              value: "spec-review",
              label: "Dossier avec points à arbitrer",
            },
          ]}
          defaultTemplate="spec-dossier"
          renderTemplatePreview={(templateValue) => {
            if (!templateValue) return "Aucun modèle sélectionné";

            switch (templateValue) {
              case "spec-summary":
                return "Synthèse courte avec périmètre, indicateurs et vue consolidée";
              case "spec-dossier":
                return "Document principal client avec synthèse puis cahier des spécifications";
              case "spec-review":
                return "Version incluant les réserves, points ouverts et arbitrages attendus";
              default:
                return "Aperçu du modèle";
            }
          }}
          onGenerate={(options) => {
            console.log("Generate specification report:", options);
          }}
        />
      ),
    },
  ],
};
  /* ============================================================
     TABS
  ============================================================ */

  const TabA = (
    <div style={tabStyle}>
      <ContainerBase {...zoneA1} />
      <ContainerBase {...zoneA2} />
    </div>
  );

  const TabB = (
    <div style={tabStyle}>
      <ContainerBase {...zoneB1} />
      <ContainerBase {...zoneB2} />
    </div>
  );

  const TabC = (
    <div style={tabStyle}>
      <ContainerBase {...zoneC1} />
      <ContainerBase {...zoneC2} />
    </div>
  );

  const TabD = (
    <div style={tabStyle}>
      <ContainerBase {...zoneD1} />
      <ContainerBase {...zoneD2} />
    </div>
  );

  const TabE = (
    <div style={tabStyle}>
      <ContainerBase {...zoneE1} />
      <ContainerBase {...zoneE2} />
    </div>
  );

  const tabs = [
    { label: "Overview", content: TabA },
    { label: "Analysis", content: TabB },
    { label: "Specification", content: TabC },
    { label: "Review", content: TabD },
    { label: "Report", content: TabE },
  ];
  const stepTexts = [
    "Comprendre les enjeux",
    "Identifier les lacunes",
    "Spécifier les exigences",
    "Sécuriser la conformité",
    "Générer le rapport",
  ];
  /* ============================================================
     RENDER
  ============================================================ */

  return (
    <div style={{ height: "100%", width: "100%" }}>
      {/* <ToolbarHeadSubpage
        left={[
          <Button key="btnNew" variant="blue">
            Nouvel élément
          </Button>,
        ]}
        center={[
          <DropdownMulti
            key="multi"
            label="Catégorie"
            options={demoOptions}
            selectedValues={selectedCategories}
            onChange={setSelectedCategories}
          />,
          <TextFilter
            key="search"
            label="Recherche"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />,
        ]}
        right={[
          <Switch
            key="switch"
            label="Actifs"
            enabled={switchOn}
            onChange={setSwitchOn}
          />,
        ]}
      /> */}

      <JourneyTabs
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      componentWidth="50%"
      stepsWidth="100%"
      componentOffsetLeft={0}
      headerPaddingLeft={24}
      tabsDisabled={false}
      containerStyle={{
        height: "calc(100vh - 160px)",
        minHeight: "calc(100vh - 160px)",
        overflow: "hidden",
      }}
    />

      
    </div>
  );
};

export default Subpage_104;